import ContentScroll from './ContentScroll'
export default ContentScroll
export type { IContentScroll } from './ContentScroll.types'
